<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
      if (window.screen.width < 768) {
      // document.getElementsByClassName('app')[0].style.width = 1240 + 'px'
      var t = window.screen.width / 1240;
      document.getElementById('app').style.width = 1240+'px'
      document.getElementById('app').style.zoom = t

    }
  }
}
</script>

<style >
#app ,body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  font-size: 12px
}

@font-face {
    font-family: 'PangMenZhengDao';
    src: url('./common/font/PangMenZhengDao.ttf');
    /* font-weight: normal; */
    /* font-style: normal; */
}
@import './common/responsive.css';
</style>



// WEBPACK FOOTER //
// src/App.vue